<template>
    <div class="accordion-details">
      <div class="financial-info">
        <h3>
        Data da Prestação:
        {{ $moment(prestacao.dtPrestacao, "YYYY-MM-DDTHH:mm:ss").locale("pt-br").format("DD/MM/YYYY") }}
        </h3>
        <div class="highlight-boxes">
            <div class="highlight">
                <div>
                    <strong>Total de Despesas</strong><br>
                    {{prestacao.nuTotalGasto | currency }}
                </div>
            </div>
            <div class="highlight">
                <div>
                    <strong>Total de Rendimentos</strong><br>
                    {{prestacao.nuTotalRendimentos | currency}}
                </div>
            </div>
            <div class="highlight">
                <div>
                    <strong>Receitas Diversas</strong><br>
                    {{prestacao.nuReceitasDiversas | currency }}
                </div>
            </div>
            <div class="highlight">
                <div>
                    <strong>Contrapartidas Econômicas</strong><br>
                    {{prestacao.valorContraPartidaEconomica | currency}}
                </div>
            </div>
            <div class="highlight">
                <div>
                    <strong>Contrapartidas Financeiras</strong><br>
                    {{prestacao.valorContraPartidaFinanceira | currency}}
                </div>
            </div>
        </div>
      </div>
      <div class="documentacao" v-if="prestacao.prestacoesContasFinal.some(p => p.documentoConvenio && p.documentoConvenio.length)">
        <h3>Documentação</h3>
        <div class="table-container">
            <table v-for="prestacaoContasFinal in prestacao.prestacoesContasFinal" :key="prestacaoContasFinal.idPrestacaoContasFinal">
                <thead v-if="prestacaoContasFinal.documentoConvenio && prestacaoContasFinal.documentoConvenio.length">
                    <tr>
                    <th>Documento</th>
                    <th>Solicitação Documento</th>
                    <th>Recebimento Documento</th>
                    <th>Descrição</th>
                    <th>Cálculo parcial do prazo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="documento in prestacaoContasFinal.documentoConvenio" :key="documento.id_Documento">
                    <td>{{documento.id_Documento}}</td>
                    <td>{{
                        documento.dataPendencia
                            ? $moment(documento.dataPendencia).format(
                                'DD/MM/YYYY'
                            )
                            : ''
                        }}</td>
                    <td>
                        {{
                        documento.dataBaixaPendencia
                            ? $moment(documento.dataBaixaPendencia).format(
                                'DD/MM/YYYY'
                            )
                            : ''
                        }}
                    </td>
                    <td>{{documento.vcDescricaoDocumento}}</td>
                    <td style="text-align: right">{{ documento.calculoParcialPrazo ? documento.calculoParcialPrazo : 0}} dia(s)</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
      <div class="highlight-boxes">
      <div class="highlight">
        <div class="highlight-icon">⏱️</div>
        <div>
            <strong>Prazo total de encerramento</strong><br>
            {{ prestacao.tempoTotalEncerramentoEmDias ? prestacao.tempoTotalEncerramentoEmDias : 0 }} dia(s)
        </div>
      </div>
      <div class="highlight">
        <div class="highlight-icon">⏳</div>
        <div>
            <strong>Tempo médio entre etapas</strong><br>
            {{ prestacao.tempoMedioEntreEtapas ? prestacao.tempoMedioEntreEtapas : 0 }} dia(s)
        </div>
      </div>
    </div>
    <div class="prazo" v-if="prestacao.timeLines && prestacao.timeLines.length">
        <h3 >Prazos de Entregas de Documentação</h3>
        <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Etapa</th>
              <th>Data</th>
              <th>Prazo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="timeLine in prestacao.timeLines" :key="timeLine.chave01">
              <td>{{timeLine.acao}}</td>
              <td>{{
                    timeLine.dataCadastro
                    ? $moment(timeLine.dataCadastro).format(
                        'DD/MM/YYYY'
                    )

                    : ''
                    }}
                </td>

              <td style="text-align: end;">{{ timeLine.prazo ? timeLine.prazo : 0 }} dia(s)</td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
  </template>
  <script>
import moment from "moment";
import "moment/locale/pt-br";
moment.locale("pt-br");

export default {

    props: {
        prestacao: {
            type: Object,
            required: true,
        },
        dtPrestacao: null,
        tempoTotalEncerramentoEmDias: '',
        calculoParcialPrazo: 0,
        tempoMedioEntreEtapas:'',
        prazoTotalEncerramento: 0
    },

    methods: {
        formatarValor(valor) {
            return valor.toFixed(2).replace('.', ',').padStart(6, '0');
        },
    },

    mounted() {

        this.prestacao.timeLines = this.prestacao.timeLines.map((p, index, array) => {
        if (index === 0) {
            return { ...p, prazo: 0 };
        }

        let dataAtual = new Date(p.dataCadastro);
        let dataAnterior = new Date(array[index - 1].dataCadastro);
        let diferenca = Math.round((dataAtual - dataAnterior) / (1000 * 60 * 60 * 24));

        return { ...p, prazo: diferenca };
        });

        this.prestacao.timeLines;

    }
}

  </script>

  <style scoped>
  .accordion-details {
    padding: 15px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    overflow-x: auto;
  }

  h3{
    margin: 10px 0;
    font-weight: bold;
    color: #333;
  }

  .financial-info ul {
    list-style-type: none;
    padding: 0;
  }

  .financial-info li {
    margin: 5px 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }

  table th, table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  table th {
    background-color: #f9f9f9;
    font-weight: bold;
  }

  .table-container {
    overflow-x: auto;
    max-width: 100%;
    }

  tfoot td {
    font-weight: bold;
    text-align: right;
  }

  .highlight-boxes {
  display: flex;
  gap: 20px;
  margin-top: 15px;
}
.highlight {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  width: 100%;
}
.highlight-icon {
  font-size: 20px;
}

  .resumo-prestacao {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.data-prestacao {
  margin-bottom: 16px;
  font-size: 14px;
  color: #333;
}

.card-container {
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px 16px;
  min-width: 160px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.card .titulo {
  font-size: 13px;
  color: #555;
  margin-bottom: 8px;
}

.card .valor {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}

@media (max-width: 768px) {

    .highlight-boxes {
        flex-direction: column;
        align-items: center;
    }

    .table-container table {
        width: 100%;
        display: block;
    }

    .table-container th, .table-container td {
        white-space: nowrap; /* Evita que os textos quebrem e fiquem desalinhados */
    }

    h3 {
        font-size: 1.3em;
    }

}
</style>
